import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _167ccd54 = () => interopDefault(import('../pages/about.vue' /* webpackChunkName: "pages/about" */))
const _21f1248e = () => interopDefault(import('../pages/account/index.vue' /* webpackChunkName: "pages/account/index" */))
const _45c5692a = () => interopDefault(import('../pages/ad.vue' /* webpackChunkName: "pages/ad" */))
const _5412b8a3 = () => interopDefault(import('../pages/ad/edit/motorhome/auction/_id.vue' /* webpackChunkName: "pages/ad/edit/motorhome/auction/_id" */))
const _408bd2b2 = () => interopDefault(import('../pages/ad/edit/motorhome/damage-more-information/_id.vue' /* webpackChunkName: "pages/ad/edit/motorhome/damage-more-information/_id" */))
const _6d5c1efc = () => interopDefault(import('../pages/ad/edit/motorhome/defects/_id.vue' /* webpackChunkName: "pages/ad/edit/motorhome/defects/_id" */))
const _0a3ebedc = () => interopDefault(import('../pages/ad/edit/motorhome/description/_id.vue' /* webpackChunkName: "pages/ad/edit/motorhome/description/_id" */))
const _477171ae = () => interopDefault(import('../pages/ad/edit/motorhome/equipment/_id.vue' /* webpackChunkName: "pages/ad/edit/motorhome/equipment/_id" */))
const _2c28e404 = () => interopDefault(import('../pages/ad/edit/motorhome/images/_id.vue' /* webpackChunkName: "pages/ad/edit/motorhome/images/_id" */))
const _112f2a7a = () => interopDefault(import('../pages/ad/edit/motorhome/last-step/_id.vue' /* webpackChunkName: "pages/ad/edit/motorhome/last-step/_id" */))
const _003b3ed0 = () => interopDefault(import('../pages/ad/edit/motorhome/more-images/_id.vue' /* webpackChunkName: "pages/ad/edit/motorhome/more-images/_id" */))
const _9aaee092 = () => interopDefault(import('../pages/ad/edit/motorhome/personal-data/_id.vue' /* webpackChunkName: "pages/ad/edit/motorhome/personal-data/_id" */))
const _bd04c3ee = () => interopDefault(import('../pages/ad/edit/motorhome/profile/_id.vue' /* webpackChunkName: "pages/ad/edit/motorhome/profile/_id" */))
const _64b47b02 = () => interopDefault(import('../pages/ad/edit/trailer/auction/_id.vue' /* webpackChunkName: "pages/ad/edit/trailer/auction/_id" */))
const _4c189a3e = () => interopDefault(import('../pages/ad/edit/trailer/defects/_id.vue' /* webpackChunkName: "pages/ad/edit/trailer/defects/_id" */))
const _d52b8c8a = () => interopDefault(import('../pages/ad/edit/trailer/description/_id.vue' /* webpackChunkName: "pages/ad/edit/trailer/description/_id" */))
const _92a7cf66 = () => interopDefault(import('../pages/ad/edit/trailer/equipment/_id.vue' /* webpackChunkName: "pages/ad/edit/trailer/equipment/_id" */))
const _8e2ef882 = () => interopDefault(import('../pages/ad/edit/trailer/images/_id.vue' /* webpackChunkName: "pages/ad/edit/trailer/images/_id" */))
const _66a31162 = () => interopDefault(import('../pages/ad/edit/trailer/last-step/_id.vue' /* webpackChunkName: "pages/ad/edit/trailer/last-step/_id" */))
const _e9328ca2 = () => interopDefault(import('../pages/ad/edit/trailer/more-images/_id.vue' /* webpackChunkName: "pages/ad/edit/trailer/more-images/_id" */))
const _20e0ced6 = () => interopDefault(import('../pages/ad/edit/trailer/personal-data/_id.vue' /* webpackChunkName: "pages/ad/edit/trailer/personal-data/_id" */))
const _9bc13f30 = () => interopDefault(import('../pages/ad/edit/trailer/profile/_id.vue' /* webpackChunkName: "pages/ad/edit/trailer/profile/_id" */))
const _49358c25 = () => interopDefault(import('../pages/ad/edit/_slug/_id.vue' /* webpackChunkName: "pages/ad/edit/_slug/_id" */))
const _74c46b92 = () => interopDefault(import('../pages/imprint.vue' /* webpackChunkName: "pages/imprint" */))
const _7ac25785 = () => interopDefault(import('../pages/agb.vue' /* webpackChunkName: "pages/agb" */))
const _ffbc66b6 = () => interopDefault(import('../pages/catalog/index.vue' /* webpackChunkName: "pages/catalog/index" */))
const _2ae9892c = () => interopDefault(import('../pages/blog/index.vue' /* webpackChunkName: "pages/blog/index" */))
const _65851fae = () => interopDefault(import('../pages/contact.vue' /* webpackChunkName: "pages/contact" */))
const _24697b91 = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _79d7cc9f = () => interopDefault(import('../pages/faq.vue' /* webpackChunkName: "pages/faq" */))
const _e500b512 = () => interopDefault(import('../pages/merchants/index.vue' /* webpackChunkName: "pages/merchants/index" */))
const _2f50a81d = () => interopDefault(import('../pages/jobs.vue' /* webpackChunkName: "pages/jobs" */))
const _43bdd19c = () => interopDefault(import('../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _58e9053c = () => interopDefault(import('../pages/vmm/index.vue' /* webpackChunkName: "pages/vmm/index" */))
const _04e694d1 = () => interopDefault(import('../pages/partner.vue' /* webpackChunkName: "pages/partner" */))
const _2673e8af = () => interopDefault(import('../pages/search.vue' /* webpackChunkName: "pages/search" */))
const _542a85ce = () => interopDefault(import('../pages/sell.vue' /* webpackChunkName: "pages/sell" */))
const _34673eae = () => interopDefault(import('../pages/vmt/index.vue' /* webpackChunkName: "pages/vmt/index" */))
const _e92d5f22 = () => interopDefault(import('../pages/account/my-vehicles.vue' /* webpackChunkName: "pages/account/my-vehicles" */))
const _be2c9210 = () => interopDefault(import('../pages/account/messages/index.vue' /* webpackChunkName: "pages/account/messages/index" */))
const _4f498d46 = () => interopDefault(import('../pages/account/email-settings.vue' /* webpackChunkName: "pages/account/email-settings" */))
const _208a638c = () => interopDefault(import('../pages/account/settings.vue' /* webpackChunkName: "pages/account/settings" */))
const _27e02530 = () => interopDefault(import('../pages/auth/logged-in.vue' /* webpackChunkName: "pages/auth/logged-in" */))
const _30ab8ac9 = () => interopDefault(import('../pages/auth/login.vue' /* webpackChunkName: "pages/auth/login" */))
const _ca8fbd70 = () => interopDefault(import('../pages/auth/redirect-to-authorize.vue' /* webpackChunkName: "pages/auth/redirect-to-authorize" */))
const _362112bd = () => interopDefault(import('../pages/auth/signing-in.vue' /* webpackChunkName: "pages/auth/signing-in" */))
const _11fe3a49 = () => interopDefault(import('../pages/auth/verify.vue' /* webpackChunkName: "pages/auth/verify" */))
const _7c2c93da = () => interopDefault(import('../pages/vmm/success.vue' /* webpackChunkName: "pages/vmm/success" */))
const _477ee39a = () => interopDefault(import('../pages/vmt/success.vue' /* webpackChunkName: "pages/vmt/success" */))
const _024b3fd2 = () => interopDefault(import('../pages/account/merchant/ads.vue' /* webpackChunkName: "pages/account/merchant/ads" */))
const _1ab7bfb0 = () => interopDefault(import('../pages/account/merchant/integrations/index.vue' /* webpackChunkName: "pages/account/merchant/integrations/index" */))
const _7767db98 = () => interopDefault(import('../pages/account/merchant/purchases.vue' /* webpackChunkName: "pages/account/merchant/purchases" */))
const _661d7ebe = () => interopDefault(import('../pages/account/merchant/news.vue' /* webpackChunkName: "pages/account/merchant/news" */))
const _5f388ed1 = () => interopDefault(import('../pages/account/merchant/guidelines.vue' /* webpackChunkName: "pages/account/merchant/guidelines" */))
const _dcb0ccb8 = () => interopDefault(import('../pages/account/merchant/searches.vue' /* webpackChunkName: "pages/account/merchant/searches" */))
const _576a470f = () => interopDefault(import('../pages/account/merchant/watchlist.vue' /* webpackChunkName: "pages/account/merchant/watchlist" */))
const _2e2fe4b8 = () => interopDefault(import('../pages/account/merchant/integrations/syscara.vue' /* webpackChunkName: "pages/account/merchant/integrations/syscara" */))
const _1479741b = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _35b6c1e2 = () => interopDefault(import('../pages/account/messages/thread/_slug.vue' /* webpackChunkName: "pages/account/messages/thread/_slug" */))
const _db0bd7e6 = () => interopDefault(import('../pages/vstepper/_id.vue' /* webpackChunkName: "pages/vstepper/_id" */))
const _9ebfdec8 = () => interopDefault(import('../pages/blog/author/_slug.vue' /* webpackChunkName: "pages/blog/author/_slug" */))
const _b1a397a6 = () => interopDefault(import('../pages/catalog/product/_id.vue' /* webpackChunkName: "pages/catalog/product/_id" */))
const _ebc41e38 = () => interopDefault(import('../pages/vmm/report/_.vue' /* webpackChunkName: "pages/vmm/report/_" */))
const _75d49230 = () => interopDefault(import('../pages/vmt/report/_slug.vue' /* webpackChunkName: "pages/vmt/report/_slug" */))
const _5e37ffbb = () => interopDefault(import('../pages/vmm/_step.vue' /* webpackChunkName: "pages/vmm/_step" */))
const _5c9b6447 = () => interopDefault(import('../pages/availability/_auctionId/_uuid.vue' /* webpackChunkName: "pages/availability/_auctionId/_uuid" */))
const _3df784b0 = () => interopDefault(import('../pages/_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _167ccd54,
    name: "about___sv"
  }, {
    path: "/about-us",
    component: _167ccd54,
    name: "about___en"
  }, {
    path: "/account",
    component: _21f1248e,
    name: "account___de"
  }, {
    path: "/account",
    component: _21f1248e,
    name: "account___en"
  }, {
    path: "/account",
    component: _21f1248e,
    name: "account___nl"
  }, {
    path: "/account",
    component: _21f1248e,
    name: "account___sv"
  }, {
    path: "/account",
    component: _21f1248e,
    name: "account___da"
  }, {
    path: "/account",
    component: _21f1248e,
    name: "account___pl"
  }, {
    path: "/account",
    component: _21f1248e,
    name: "account___es"
  }, {
    path: "/account",
    component: _21f1248e,
    name: "account___cs"
  }, {
    path: "/ad",
    component: _45c5692a,
    name: "ad___en",
    children: [{
      path: "edit/motorhome/auction/:id?",
      component: _5412b8a3,
      name: "ad-edit-motorhome-auction-id___en"
    }, {
      path: "edit/motorhome/damage-more-information/:id?",
      component: _408bd2b2,
      name: "ad-edit-motorhome-damage-more-information-id___en"
    }, {
      path: "edit/motorhome/defects/:id?",
      component: _6d5c1efc,
      name: "ad-edit-motorhome-defects-id___en"
    }, {
      path: "edit/motorhome/description/:id?",
      component: _0a3ebedc,
      name: "ad-edit-motorhome-description-id___en"
    }, {
      path: "edit/motorhome/equipment/:id?",
      component: _477171ae,
      name: "ad-edit-motorhome-equipment-id___en"
    }, {
      path: "edit/motorhome/images/:id?",
      component: _2c28e404,
      name: "ad-edit-motorhome-images-id___en"
    }, {
      path: "edit/motorhome/last-step/:id?",
      component: _112f2a7a,
      name: "ad-edit-motorhome-last-step-id___en"
    }, {
      path: "edit/motorhome/more-images/:id?",
      component: _003b3ed0,
      name: "ad-edit-motorhome-more-images-id___en"
    }, {
      path: "edit/motorhome/personal-data/:id?",
      component: _9aaee092,
      name: "ad-edit-motorhome-personal-data-id___en"
    }, {
      path: "edit/motorhome/profile/:id?",
      component: _bd04c3ee,
      name: "ad-edit-motorhome-profile-id___en"
    }, {
      path: "edit/trailer/auction/:id?",
      component: _64b47b02,
      name: "ad-edit-trailer-auction-id___en"
    }, {
      path: "edit/trailer/defects/:id?",
      component: _4c189a3e,
      name: "ad-edit-trailer-defects-id___en"
    }, {
      path: "edit/trailer/description/:id?",
      component: _d52b8c8a,
      name: "ad-edit-trailer-description-id___en"
    }, {
      path: "edit/trailer/equipment/:id?",
      component: _92a7cf66,
      name: "ad-edit-trailer-equipment-id___en"
    }, {
      path: "edit/trailer/images/:id?",
      component: _8e2ef882,
      name: "ad-edit-trailer-images-id___en"
    }, {
      path: "edit/trailer/last-step/:id?",
      component: _66a31162,
      name: "ad-edit-trailer-last-step-id___en"
    }, {
      path: "edit/trailer/more-images/:id?",
      component: _e9328ca2,
      name: "ad-edit-trailer-more-images-id___en"
    }, {
      path: "edit/trailer/personal-data/:id?",
      component: _20e0ced6,
      name: "ad-edit-trailer-personal-data-id___en"
    }, {
      path: "edit/trailer/profile/:id?",
      component: _9bc13f30,
      name: "ad-edit-trailer-profile-id___en"
    }, {
      path: "edit/:slug?/:id?",
      component: _49358c25,
      name: "ad-edit-slug-id___en"
    }]
  }, {
    path: "/ad",
    component: _45c5692a,
    name: "ad___nl",
    children: [{
      path: "edit/motorhome/auction/:id?",
      component: _5412b8a3,
      name: "ad-edit-motorhome-auction-id___nl"
    }, {
      path: "edit/motorhome/damage-more-information/:id?",
      component: _408bd2b2,
      name: "ad-edit-motorhome-damage-more-information-id___nl"
    }, {
      path: "edit/motorhome/defects/:id?",
      component: _6d5c1efc,
      name: "ad-edit-motorhome-defects-id___nl"
    }, {
      path: "edit/motorhome/description/:id?",
      component: _0a3ebedc,
      name: "ad-edit-motorhome-description-id___nl"
    }, {
      path: "edit/motorhome/equipment/:id?",
      component: _477171ae,
      name: "ad-edit-motorhome-equipment-id___nl"
    }, {
      path: "edit/motorhome/images/:id?",
      component: _2c28e404,
      name: "ad-edit-motorhome-images-id___nl"
    }, {
      path: "edit/motorhome/last-step/:id?",
      component: _112f2a7a,
      name: "ad-edit-motorhome-last-step-id___nl"
    }, {
      path: "edit/motorhome/more-images/:id?",
      component: _003b3ed0,
      name: "ad-edit-motorhome-more-images-id___nl"
    }, {
      path: "edit/motorhome/personal-data/:id?",
      component: _9aaee092,
      name: "ad-edit-motorhome-personal-data-id___nl"
    }, {
      path: "edit/motorhome/profile/:id?",
      component: _bd04c3ee,
      name: "ad-edit-motorhome-profile-id___nl"
    }, {
      path: "edit/trailer/auction/:id?",
      component: _64b47b02,
      name: "ad-edit-trailer-auction-id___nl"
    }, {
      path: "edit/trailer/defects/:id?",
      component: _4c189a3e,
      name: "ad-edit-trailer-defects-id___nl"
    }, {
      path: "edit/trailer/description/:id?",
      component: _d52b8c8a,
      name: "ad-edit-trailer-description-id___nl"
    }, {
      path: "edit/trailer/equipment/:id?",
      component: _92a7cf66,
      name: "ad-edit-trailer-equipment-id___nl"
    }, {
      path: "edit/trailer/images/:id?",
      component: _8e2ef882,
      name: "ad-edit-trailer-images-id___nl"
    }, {
      path: "edit/trailer/last-step/:id?",
      component: _66a31162,
      name: "ad-edit-trailer-last-step-id___nl"
    }, {
      path: "edit/trailer/more-images/:id?",
      component: _e9328ca2,
      name: "ad-edit-trailer-more-images-id___nl"
    }, {
      path: "edit/trailer/personal-data/:id?",
      component: _20e0ced6,
      name: "ad-edit-trailer-personal-data-id___nl"
    }, {
      path: "edit/trailer/profile/:id?",
      component: _9bc13f30,
      name: "ad-edit-trailer-profile-id___nl"
    }, {
      path: "edit/:slug?/:id?",
      component: _49358c25,
      name: "ad-edit-slug-id___nl"
    }]
  }, {
    path: "/ad",
    component: _45c5692a,
    name: "ad___sv",
    children: [{
      path: "edit/motorhome/auction/:id?",
      component: _5412b8a3,
      name: "ad-edit-motorhome-auction-id___sv"
    }, {
      path: "edit/motorhome/damage-more-information/:id?",
      component: _408bd2b2,
      name: "ad-edit-motorhome-damage-more-information-id___sv"
    }, {
      path: "edit/motorhome/defects/:id?",
      component: _6d5c1efc,
      name: "ad-edit-motorhome-defects-id___sv"
    }, {
      path: "edit/motorhome/description/:id?",
      component: _0a3ebedc,
      name: "ad-edit-motorhome-description-id___sv"
    }, {
      path: "edit/motorhome/equipment/:id?",
      component: _477171ae,
      name: "ad-edit-motorhome-equipment-id___sv"
    }, {
      path: "edit/motorhome/images/:id?",
      component: _2c28e404,
      name: "ad-edit-motorhome-images-id___sv"
    }, {
      path: "edit/motorhome/last-step/:id?",
      component: _112f2a7a,
      name: "ad-edit-motorhome-last-step-id___sv"
    }, {
      path: "edit/motorhome/more-images/:id?",
      component: _003b3ed0,
      name: "ad-edit-motorhome-more-images-id___sv"
    }, {
      path: "edit/motorhome/personal-data/:id?",
      component: _9aaee092,
      name: "ad-edit-motorhome-personal-data-id___sv"
    }, {
      path: "edit/motorhome/profile/:id?",
      component: _bd04c3ee,
      name: "ad-edit-motorhome-profile-id___sv"
    }, {
      path: "edit/trailer/auction/:id?",
      component: _64b47b02,
      name: "ad-edit-trailer-auction-id___sv"
    }, {
      path: "edit/trailer/defects/:id?",
      component: _4c189a3e,
      name: "ad-edit-trailer-defects-id___sv"
    }, {
      path: "edit/trailer/description/:id?",
      component: _d52b8c8a,
      name: "ad-edit-trailer-description-id___sv"
    }, {
      path: "edit/trailer/equipment/:id?",
      component: _92a7cf66,
      name: "ad-edit-trailer-equipment-id___sv"
    }, {
      path: "edit/trailer/images/:id?",
      component: _8e2ef882,
      name: "ad-edit-trailer-images-id___sv"
    }, {
      path: "edit/trailer/last-step/:id?",
      component: _66a31162,
      name: "ad-edit-trailer-last-step-id___sv"
    }, {
      path: "edit/trailer/more-images/:id?",
      component: _e9328ca2,
      name: "ad-edit-trailer-more-images-id___sv"
    }, {
      path: "edit/trailer/personal-data/:id?",
      component: _20e0ced6,
      name: "ad-edit-trailer-personal-data-id___sv"
    }, {
      path: "edit/trailer/profile/:id?",
      component: _9bc13f30,
      name: "ad-edit-trailer-profile-id___sv"
    }, {
      path: "edit/:slug?/:id?",
      component: _49358c25,
      name: "ad-edit-slug-id___sv"
    }]
  }, {
    path: "/ad",
    component: _45c5692a,
    name: "ad___da",
    children: [{
      path: "edit/motorhome/auction/:id?",
      component: _5412b8a3,
      name: "ad-edit-motorhome-auction-id___da"
    }, {
      path: "edit/motorhome/damage-more-information/:id?",
      component: _408bd2b2,
      name: "ad-edit-motorhome-damage-more-information-id___da"
    }, {
      path: "edit/motorhome/defects/:id?",
      component: _6d5c1efc,
      name: "ad-edit-motorhome-defects-id___da"
    }, {
      path: "edit/motorhome/description/:id?",
      component: _0a3ebedc,
      name: "ad-edit-motorhome-description-id___da"
    }, {
      path: "edit/motorhome/equipment/:id?",
      component: _477171ae,
      name: "ad-edit-motorhome-equipment-id___da"
    }, {
      path: "edit/motorhome/images/:id?",
      component: _2c28e404,
      name: "ad-edit-motorhome-images-id___da"
    }, {
      path: "edit/motorhome/last-step/:id?",
      component: _112f2a7a,
      name: "ad-edit-motorhome-last-step-id___da"
    }, {
      path: "edit/motorhome/more-images/:id?",
      component: _003b3ed0,
      name: "ad-edit-motorhome-more-images-id___da"
    }, {
      path: "edit/motorhome/personal-data/:id?",
      component: _9aaee092,
      name: "ad-edit-motorhome-personal-data-id___da"
    }, {
      path: "edit/motorhome/profile/:id?",
      component: _bd04c3ee,
      name: "ad-edit-motorhome-profile-id___da"
    }, {
      path: "edit/trailer/auction/:id?",
      component: _64b47b02,
      name: "ad-edit-trailer-auction-id___da"
    }, {
      path: "edit/trailer/defects/:id?",
      component: _4c189a3e,
      name: "ad-edit-trailer-defects-id___da"
    }, {
      path: "edit/trailer/description/:id?",
      component: _d52b8c8a,
      name: "ad-edit-trailer-description-id___da"
    }, {
      path: "edit/trailer/equipment/:id?",
      component: _92a7cf66,
      name: "ad-edit-trailer-equipment-id___da"
    }, {
      path: "edit/trailer/images/:id?",
      component: _8e2ef882,
      name: "ad-edit-trailer-images-id___da"
    }, {
      path: "edit/trailer/last-step/:id?",
      component: _66a31162,
      name: "ad-edit-trailer-last-step-id___da"
    }, {
      path: "edit/trailer/more-images/:id?",
      component: _e9328ca2,
      name: "ad-edit-trailer-more-images-id___da"
    }, {
      path: "edit/trailer/personal-data/:id?",
      component: _20e0ced6,
      name: "ad-edit-trailer-personal-data-id___da"
    }, {
      path: "edit/trailer/profile/:id?",
      component: _9bc13f30,
      name: "ad-edit-trailer-profile-id___da"
    }, {
      path: "edit/:slug?/:id?",
      component: _49358c25,
      name: "ad-edit-slug-id___da"
    }]
  }, {
    path: "/ad",
    component: _45c5692a,
    name: "ad___pl",
    children: [{
      path: "edit/motorhome/auction/:id?",
      component: _5412b8a3,
      name: "ad-edit-motorhome-auction-id___pl"
    }, {
      path: "edit/motorhome/damage-more-information/:id?",
      component: _408bd2b2,
      name: "ad-edit-motorhome-damage-more-information-id___pl"
    }, {
      path: "edit/motorhome/defects/:id?",
      component: _6d5c1efc,
      name: "ad-edit-motorhome-defects-id___pl"
    }, {
      path: "edit/motorhome/description/:id?",
      component: _0a3ebedc,
      name: "ad-edit-motorhome-description-id___pl"
    }, {
      path: "edit/motorhome/equipment/:id?",
      component: _477171ae,
      name: "ad-edit-motorhome-equipment-id___pl"
    }, {
      path: "edit/motorhome/images/:id?",
      component: _2c28e404,
      name: "ad-edit-motorhome-images-id___pl"
    }, {
      path: "edit/motorhome/last-step/:id?",
      component: _112f2a7a,
      name: "ad-edit-motorhome-last-step-id___pl"
    }, {
      path: "edit/motorhome/more-images/:id?",
      component: _003b3ed0,
      name: "ad-edit-motorhome-more-images-id___pl"
    }, {
      path: "edit/motorhome/personal-data/:id?",
      component: _9aaee092,
      name: "ad-edit-motorhome-personal-data-id___pl"
    }, {
      path: "edit/motorhome/profile/:id?",
      component: _bd04c3ee,
      name: "ad-edit-motorhome-profile-id___pl"
    }, {
      path: "edit/trailer/auction/:id?",
      component: _64b47b02,
      name: "ad-edit-trailer-auction-id___pl"
    }, {
      path: "edit/trailer/defects/:id?",
      component: _4c189a3e,
      name: "ad-edit-trailer-defects-id___pl"
    }, {
      path: "edit/trailer/description/:id?",
      component: _d52b8c8a,
      name: "ad-edit-trailer-description-id___pl"
    }, {
      path: "edit/trailer/equipment/:id?",
      component: _92a7cf66,
      name: "ad-edit-trailer-equipment-id___pl"
    }, {
      path: "edit/trailer/images/:id?",
      component: _8e2ef882,
      name: "ad-edit-trailer-images-id___pl"
    }, {
      path: "edit/trailer/last-step/:id?",
      component: _66a31162,
      name: "ad-edit-trailer-last-step-id___pl"
    }, {
      path: "edit/trailer/more-images/:id?",
      component: _e9328ca2,
      name: "ad-edit-trailer-more-images-id___pl"
    }, {
      path: "edit/trailer/personal-data/:id?",
      component: _20e0ced6,
      name: "ad-edit-trailer-personal-data-id___pl"
    }, {
      path: "edit/trailer/profile/:id?",
      component: _9bc13f30,
      name: "ad-edit-trailer-profile-id___pl"
    }, {
      path: "edit/:slug?/:id?",
      component: _49358c25,
      name: "ad-edit-slug-id___pl"
    }]
  }, {
    path: "/ad",
    component: _45c5692a,
    name: "ad___es",
    children: [{
      path: "edit/motorhome/auction/:id?",
      component: _5412b8a3,
      name: "ad-edit-motorhome-auction-id___es"
    }, {
      path: "edit/motorhome/damage-more-information/:id?",
      component: _408bd2b2,
      name: "ad-edit-motorhome-damage-more-information-id___es"
    }, {
      path: "edit/motorhome/defects/:id?",
      component: _6d5c1efc,
      name: "ad-edit-motorhome-defects-id___es"
    }, {
      path: "edit/motorhome/description/:id?",
      component: _0a3ebedc,
      name: "ad-edit-motorhome-description-id___es"
    }, {
      path: "edit/motorhome/equipment/:id?",
      component: _477171ae,
      name: "ad-edit-motorhome-equipment-id___es"
    }, {
      path: "edit/motorhome/images/:id?",
      component: _2c28e404,
      name: "ad-edit-motorhome-images-id___es"
    }, {
      path: "edit/motorhome/last-step/:id?",
      component: _112f2a7a,
      name: "ad-edit-motorhome-last-step-id___es"
    }, {
      path: "edit/motorhome/more-images/:id?",
      component: _003b3ed0,
      name: "ad-edit-motorhome-more-images-id___es"
    }, {
      path: "edit/motorhome/personal-data/:id?",
      component: _9aaee092,
      name: "ad-edit-motorhome-personal-data-id___es"
    }, {
      path: "edit/motorhome/profile/:id?",
      component: _bd04c3ee,
      name: "ad-edit-motorhome-profile-id___es"
    }, {
      path: "edit/trailer/auction/:id?",
      component: _64b47b02,
      name: "ad-edit-trailer-auction-id___es"
    }, {
      path: "edit/trailer/defects/:id?",
      component: _4c189a3e,
      name: "ad-edit-trailer-defects-id___es"
    }, {
      path: "edit/trailer/description/:id?",
      component: _d52b8c8a,
      name: "ad-edit-trailer-description-id___es"
    }, {
      path: "edit/trailer/equipment/:id?",
      component: _92a7cf66,
      name: "ad-edit-trailer-equipment-id___es"
    }, {
      path: "edit/trailer/images/:id?",
      component: _8e2ef882,
      name: "ad-edit-trailer-images-id___es"
    }, {
      path: "edit/trailer/last-step/:id?",
      component: _66a31162,
      name: "ad-edit-trailer-last-step-id___es"
    }, {
      path: "edit/trailer/more-images/:id?",
      component: _e9328ca2,
      name: "ad-edit-trailer-more-images-id___es"
    }, {
      path: "edit/trailer/personal-data/:id?",
      component: _20e0ced6,
      name: "ad-edit-trailer-personal-data-id___es"
    }, {
      path: "edit/trailer/profile/:id?",
      component: _9bc13f30,
      name: "ad-edit-trailer-profile-id___es"
    }, {
      path: "edit/:slug?/:id?",
      component: _49358c25,
      name: "ad-edit-slug-id___es"
    }]
  }, {
    path: "/ad",
    component: _45c5692a,
    name: "ad___cs",
    children: [{
      path: "edit/motorhome/auction/:id?",
      component: _5412b8a3,
      name: "ad-edit-motorhome-auction-id___cs"
    }, {
      path: "edit/motorhome/damage-more-information/:id?",
      component: _408bd2b2,
      name: "ad-edit-motorhome-damage-more-information-id___cs"
    }, {
      path: "edit/motorhome/defects/:id?",
      component: _6d5c1efc,
      name: "ad-edit-motorhome-defects-id___cs"
    }, {
      path: "edit/motorhome/description/:id?",
      component: _0a3ebedc,
      name: "ad-edit-motorhome-description-id___cs"
    }, {
      path: "edit/motorhome/equipment/:id?",
      component: _477171ae,
      name: "ad-edit-motorhome-equipment-id___cs"
    }, {
      path: "edit/motorhome/images/:id?",
      component: _2c28e404,
      name: "ad-edit-motorhome-images-id___cs"
    }, {
      path: "edit/motorhome/last-step/:id?",
      component: _112f2a7a,
      name: "ad-edit-motorhome-last-step-id___cs"
    }, {
      path: "edit/motorhome/more-images/:id?",
      component: _003b3ed0,
      name: "ad-edit-motorhome-more-images-id___cs"
    }, {
      path: "edit/motorhome/personal-data/:id?",
      component: _9aaee092,
      name: "ad-edit-motorhome-personal-data-id___cs"
    }, {
      path: "edit/motorhome/profile/:id?",
      component: _bd04c3ee,
      name: "ad-edit-motorhome-profile-id___cs"
    }, {
      path: "edit/trailer/auction/:id?",
      component: _64b47b02,
      name: "ad-edit-trailer-auction-id___cs"
    }, {
      path: "edit/trailer/defects/:id?",
      component: _4c189a3e,
      name: "ad-edit-trailer-defects-id___cs"
    }, {
      path: "edit/trailer/description/:id?",
      component: _d52b8c8a,
      name: "ad-edit-trailer-description-id___cs"
    }, {
      path: "edit/trailer/equipment/:id?",
      component: _92a7cf66,
      name: "ad-edit-trailer-equipment-id___cs"
    }, {
      path: "edit/trailer/images/:id?",
      component: _8e2ef882,
      name: "ad-edit-trailer-images-id___cs"
    }, {
      path: "edit/trailer/last-step/:id?",
      component: _66a31162,
      name: "ad-edit-trailer-last-step-id___cs"
    }, {
      path: "edit/trailer/more-images/:id?",
      component: _e9328ca2,
      name: "ad-edit-trailer-more-images-id___cs"
    }, {
      path: "edit/trailer/personal-data/:id?",
      component: _20e0ced6,
      name: "ad-edit-trailer-personal-data-id___cs"
    }, {
      path: "edit/trailer/profile/:id?",
      component: _9bc13f30,
      name: "ad-edit-trailer-profile-id___cs"
    }, {
      path: "edit/:slug?/:id?",
      component: _49358c25,
      name: "ad-edit-slug-id___cs"
    }]
  }, {
    path: "/afdruk",
    component: _74c46b92,
    name: "imprint___nl"
  }, {
    path: "/aftryk",
    component: _74c46b92,
    name: "imprint___da"
  }, {
    path: "/agb",
    component: _7ac25785,
    name: "agb___de"
  }, {
    path: "/agb",
    component: _7ac25785,
    name: "agb___nl"
  }, {
    path: "/agb",
    component: _7ac25785,
    name: "agb___sv"
  }, {
    path: "/agb",
    component: _7ac25785,
    name: "agb___da"
  }, {
    path: "/agb",
    component: _7ac25785,
    name: "agb___pl"
  }, {
    path: "/agb",
    component: _7ac25785,
    name: "agb___es"
  }, {
    path: "/agb",
    component: _7ac25785,
    name: "agb___cs"
  }, {
    path: "/buy-a-motorhome",
    component: _ffbc66b6,
    name: "catalog___en"
  }, {
    path: "/camper-verkopen-gids",
    component: _2ae9892c,
    name: "blog___nl"
  }, {
    path: "/catalog",
    component: _ffbc66b6,
    name: "catalog___sv"
  }, {
    path: "/comprar-una-autocaravana",
    component: _ffbc66b6,
    name: "catalog___es"
  }, {
    path: "/contact",
    component: _65851fae,
    name: "contact___en"
  }, {
    path: "/contact",
    component: _65851fae,
    name: "contact___nl"
  }, {
    path: "/contact",
    component: _65851fae,
    name: "contact___sv"
  }, {
    path: "/contacto",
    component: _65851fae,
    name: "contact___es"
  }, {
    path: "/datenschutz",
    component: _24697b91,
    name: "privacy___de"
  }, {
    path: "/faq",
    component: _79d7cc9f,
    name: "faq___de"
  }, {
    path: "/faq",
    component: _79d7cc9f,
    name: "faq___en"
  }, {
    path: "/faq",
    component: _79d7cc9f,
    name: "faq___nl"
  }, {
    path: "/faq",
    component: _79d7cc9f,
    name: "faq___sv"
  }, {
    path: "/faq",
    component: _79d7cc9f,
    name: "faq___da"
  }, {
    path: "/faq",
    component: _79d7cc9f,
    name: "faq___pl"
  }, {
    path: "/faq",
    component: _79d7cc9f,
    name: "faq___es"
  }, {
    path: "/faq",
    component: _79d7cc9f,
    name: "faq___cs"
  }, {
    path: "/guia-para-vender-autocaravana",
    component: _2ae9892c,
    name: "blog___es"
  }, {
    path: "/haendlerverzeichnis",
    component: _e500b512,
    name: "merchants___de"
  }, {
    path: "/haendlerverzeichnis",
    component: _e500b512,
    name: "merchants___nl"
  }, {
    path: "/haendlerverzeichnis",
    component: _e500b512,
    name: "merchants___da"
  }, {
    path: "/haendlerverzeichnis",
    component: _e500b512,
    name: "merchants___pl"
  }, {
    path: "/haendlerverzeichnis",
    component: _e500b512,
    name: "merchants___es"
  }, {
    path: "/haendlerverzeichnis",
    component: _e500b512,
    name: "merchants___cs"
  }, {
    path: "/impressum",
    component: _74c46b92,
    name: "imprint___de"
  }, {
    path: "/imprimir",
    component: _74c46b92,
    name: "imprint___es"
  }, {
    path: "/imprint",
    component: _74c46b92,
    name: "imprint___en"
  }, {
    path: "/imprint",
    component: _74c46b92,
    name: "imprint___sv"
  }, {
    path: "/inserat",
    component: _45c5692a,
    name: "ad___de",
    children: [{
      path: "/inserat/bearbeiten/wohnmobil/auktion/:id",
      component: _5412b8a3,
      name: "ad-edit-motorhome-auction-id___de"
    }, {
      path: "/inserat/bearbeiten/wohnmobil/ausstattung/:id",
      component: _477171ae,
      name: "ad-edit-motorhome-equipment-id___de"
    }, {
      path: "/inserat/bearbeiten/wohnmobil/beschreibung/:id",
      component: _0a3ebedc,
      name: "ad-edit-motorhome-description-id___de"
    }, {
      path: "/inserat/bearbeiten/wohnmobil/bilder/:id",
      component: _2c28e404,
      name: "ad-edit-motorhome-images-id___de"
    }, {
      path: "/inserat/bearbeiten/wohnmobil/letzter-schritt/:id",
      component: _112f2a7a,
      name: "ad-edit-motorhome-last-step-id___de"
    }, {
      path: "/inserat/bearbeiten/wohnmobil/maengel/:id",
      component: _6d5c1efc,
      name: "ad-edit-motorhome-defects-id___de"
    }, {
      path: "/inserat/bearbeiten/wohnmobil/mehr-bilder/:id",
      component: _003b3ed0,
      name: "ad-edit-motorhome-more-images-id___de"
    }, {
      path: "/inserat/bearbeiten/wohnmobil/meine-daten/:id",
      component: _9aaee092,
      name: "ad-edit-motorhome-personal-data-id___de"
    }, {
      path: "/inserat/bearbeiten/wohnmobil/profil/:id",
      component: _bd04c3ee,
      name: "ad-edit-motorhome-profile-id___de"
    }, {
      path: "/inserat/bearbeiten/wohnmobil/schaden-mehr-informationen/:id",
      component: _408bd2b2,
      name: "ad-edit-motorhome-damage-more-information-id___de"
    }, {
      path: "/inserat/bearbeiten/wohnwagen/auktion/:id",
      component: _64b47b02,
      name: "ad-edit-trailer-auction-id___de"
    }, {
      path: "/inserat/bearbeiten/wohnwagen/ausstattung/:id",
      component: _92a7cf66,
      name: "ad-edit-trailer-equipment-id___de"
    }, {
      path: "/inserat/bearbeiten/wohnwagen/beschreibung/:id",
      component: _d52b8c8a,
      name: "ad-edit-trailer-description-id___de"
    }, {
      path: "/inserat/bearbeiten/wohnwagen/bilder/:id",
      component: _8e2ef882,
      name: "ad-edit-trailer-images-id___de"
    }, {
      path: "/inserat/bearbeiten/wohnwagen/letzter-schritt/:id",
      component: _66a31162,
      name: "ad-edit-trailer-last-step-id___de"
    }, {
      path: "/inserat/bearbeiten/wohnwagen/maengel/:id",
      component: _4c189a3e,
      name: "ad-edit-trailer-defects-id___de"
    }, {
      path: "/inserat/bearbeiten/wohnwagen/mehr-bilder/:id",
      component: _e9328ca2,
      name: "ad-edit-trailer-more-images-id___de"
    }, {
      path: "/inserat/bearbeiten/wohnwagen/meine-daten/:id",
      component: _20e0ced6,
      name: "ad-edit-trailer-personal-data-id___de"
    }, {
      path: "/inserat/bearbeiten/wohnwagen/profil/:id",
      component: _9bc13f30,
      name: "ad-edit-trailer-profile-id___de"
    }, {
      path: "/inserat/bearbeiten/:slug/:id",
      component: _49358c25,
      name: "ad-edit-slug-id___de"
    }]
  }, {
    path: "/jobs",
    component: _2f50a81d,
    name: "jobs___de"
  }, {
    path: "/jobs",
    component: _2f50a81d,
    name: "jobs___en"
  }, {
    path: "/jobs",
    component: _2f50a81d,
    name: "jobs___nl"
  }, {
    path: "/jobs",
    component: _2f50a81d,
    name: "jobs___sv"
  }, {
    path: "/jobs",
    component: _2f50a81d,
    name: "jobs___da"
  }, {
    path: "/jobs",
    component: _2f50a81d,
    name: "jobs___pl"
  }, {
    path: "/jobs",
    component: _2f50a81d,
    name: "jobs___es"
  }, {
    path: "/jobs",
    component: _2f50a81d,
    name: "jobs___cs"
  }, {
    path: "/kob-en-autocamper",
    component: _ffbc66b6,
    name: "catalog___da"
  }, {
    path: "/kontakt",
    component: _65851fae,
    name: "contact___de"
  }, {
    path: "/kontakt",
    component: _65851fae,
    name: "contact___da"
  }, {
    path: "/kontakt",
    component: _65851fae,
    name: "contact___pl"
  }, {
    path: "/kontakt",
    component: _65851fae,
    name: "contact___cs"
  }, {
    path: "/koop-een-camper",
    component: _ffbc66b6,
    name: "catalog___nl"
  }, {
    path: "/koupit-automobil",
    component: _ffbc66b6,
    name: "catalog___cs"
  }, {
    path: "/kup-kamper",
    component: _ffbc66b6,
    name: "catalog___pl"
  }, {
    path: "/login",
    component: _43bdd19c,
    name: "login___de"
  }, {
    path: "/login",
    component: _43bdd19c,
    name: "login___en"
  }, {
    path: "/login",
    component: _43bdd19c,
    name: "login___nl"
  }, {
    path: "/login",
    component: _43bdd19c,
    name: "login___sv"
  }, {
    path: "/login",
    component: _43bdd19c,
    name: "login___da"
  }, {
    path: "/login",
    component: _43bdd19c,
    name: "login___pl"
  }, {
    path: "/login",
    component: _43bdd19c,
    name: "login___es"
  }, {
    path: "/login",
    component: _43bdd19c,
    name: "login___cs"
  }, {
    path: "/merchant-listing",
    component: _e500b512,
    name: "merchants___en"
  }, {
    path: "/merchants",
    component: _e500b512,
    name: "merchants___sv"
  }, {
    path: "/o-nas",
    component: _167ccd54,
    name: "about___pl"
  }, {
    path: "/o-nas",
    component: _167ccd54,
    name: "about___cs"
  }, {
    path: "/ocen-moj-kamper",
    component: _58e9053c,
    name: "vmm___pl"
  }, {
    path: "/odcisk",
    component: _74c46b92,
    name: "imprint___pl"
  }, {
    path: "/ohodnotit-muj-motorhome",
    component: _58e9053c,
    name: "vmm___cs"
  }, {
    path: "/om-os",
    component: _167ccd54,
    name: "about___da"
  }, {
    path: "/otisk",
    component: _74c46b92,
    name: "imprint___cs"
  }, {
    path: "/over-ons",
    component: _167ccd54,
    name: "about___nl"
  }, {
    path: "/partner",
    component: _04e694d1,
    name: "partner___de"
  }, {
    path: "/partner",
    component: _04e694d1,
    name: "partner___en"
  }, {
    path: "/partner",
    component: _04e694d1,
    name: "partner___nl"
  }, {
    path: "/partner",
    component: _04e694d1,
    name: "partner___sv"
  }, {
    path: "/partner",
    component: _04e694d1,
    name: "partner___da"
  }, {
    path: "/partner",
    component: _04e694d1,
    name: "partner___pl"
  }, {
    path: "/partner",
    component: _04e694d1,
    name: "partner___es"
  }, {
    path: "/partner",
    component: _04e694d1,
    name: "partner___cs"
  }, {
    path: "/privacy",
    component: _24697b91,
    name: "privacy___en"
  }, {
    path: "/privacy",
    component: _24697b91,
    name: "privacy___nl"
  }, {
    path: "/privacy",
    component: _24697b91,
    name: "privacy___sv"
  }, {
    path: "/privacy",
    component: _24697b91,
    name: "privacy___da"
  }, {
    path: "/privacy",
    component: _24697b91,
    name: "privacy___pl"
  }, {
    path: "/privacy",
    component: _24697b91,
    name: "privacy___es"
  }, {
    path: "/privacy",
    component: _24697b91,
    name: "privacy___cs"
  }, {
    path: "/pruvodce-prodejem-motorhome",
    component: _2ae9892c,
    name: "blog___cs"
  }, {
    path: "/przewodnik-sprzedazy-motorhome",
    component: _2ae9892c,
    name: "blog___pl"
  }, {
    path: "/saelge-autocamper-guide",
    component: _2ae9892c,
    name: "blog___da"
  }, {
    path: "/saell-husbil-guide",
    component: _2ae9892c,
    name: "blog___sv"
  }, {
    path: "/search",
    component: _2673e8af,
    name: "search___en"
  }, {
    path: "/search",
    component: _2673e8af,
    name: "search___nl"
  }, {
    path: "/search",
    component: _2673e8af,
    name: "search___sv"
  }, {
    path: "/search",
    component: _2673e8af,
    name: "search___da"
  }, {
    path: "/search",
    component: _2673e8af,
    name: "search___pl"
  }, {
    path: "/search",
    component: _2673e8af,
    name: "search___es"
  }, {
    path: "/search",
    component: _2673e8af,
    name: "search___cs"
  }, {
    path: "/sell",
    component: _542a85ce,
    name: "sell___sv"
  }, {
    path: "/sell-motorhome-guide",
    component: _2ae9892c,
    name: "blog___en"
  }, {
    path: "/sobre-nosotros",
    component: _167ccd54,
    name: "about___es"
  }, {
    path: "/suchen",
    component: _2673e8af,
    name: "search___de"
  }, {
    path: "/tac",
    component: _7ac25785,
    name: "agb___en"
  }, {
    path: "/ueber-uns",
    component: _167ccd54,
    name: "about___de"
  }, {
    path: "/valora-mi-autocaravana",
    component: _58e9053c,
    name: "vmm___es"
  }, {
    path: "/valuate-my-motorhome",
    component: _58e9053c,
    name: "vmm___en"
  }, {
    path: "/valuate-my-trailer",
    component: _34673eae,
    name: "vmt___en"
  }, {
    path: "/valuate-my-trailer",
    component: _34673eae,
    name: "vmt___nl"
  }, {
    path: "/valuate-my-trailer",
    component: _34673eae,
    name: "vmt___da"
  }, {
    path: "/valuate-my-trailer",
    component: _34673eae,
    name: "vmt___pl"
  }, {
    path: "/valuate-my-trailer",
    component: _34673eae,
    name: "vmt___es"
  }, {
    path: "/valuate-my-trailer",
    component: _34673eae,
    name: "vmt___cs"
  }, {
    path: "/vmm",
    component: _58e9053c,
    name: "vmm___sv"
  }, {
    path: "/vmt",
    component: _34673eae,
    name: "vmt___sv"
  }, {
    path: "/vurder-min-autocamper",
    component: _58e9053c,
    name: "vmm___da"
  }, {
    path: "/waardeer-mijn-camper",
    component: _58e9053c,
    name: "vmm___nl"
  }, {
    path: "/wohnmobil-bewerten",
    component: _58e9053c,
    name: "vmm___de"
  }, {
    path: "/wohnmobil-kaufen",
    component: _ffbc66b6,
    name: "catalog___de"
  }, {
    path: "/wohnmobil-verkaufen-ratgeber",
    component: _2ae9892c,
    name: "blog___de"
  }, {
    path: "/wohnwagen-bewerten",
    component: _34673eae,
    name: "vmt___de"
  }, {
    path: "/a/meine-fahrzeuge",
    component: _e92d5f22,
    name: "account-my-vehicles___de"
  }, {
    path: "/a/messages",
    component: _be2c9210,
    name: "account-messages___en"
  }, {
    path: "/a/messages",
    component: _be2c9210,
    name: "account-messages___nl"
  }, {
    path: "/a/messages",
    component: _be2c9210,
    name: "account-messages___sv"
  }, {
    path: "/a/messages",
    component: _be2c9210,
    name: "account-messages___pl"
  }, {
    path: "/a/messages",
    component: _be2c9210,
    name: "account-messages___es"
  }, {
    path: "/a/messages",
    component: _be2c9210,
    name: "account-messages___cs"
  }, {
    path: "/a/my-caravans",
    component: _e92d5f22,
    name: "account-my-vehicles___en"
  }, {
    path: "/a/my-caravans",
    component: _e92d5f22,
    name: "account-my-vehicles___nl"
  }, {
    path: "/a/my-caravans",
    component: _e92d5f22,
    name: "account-my-vehicles___sv"
  }, {
    path: "/a/my-caravans",
    component: _e92d5f22,
    name: "account-my-vehicles___pl"
  }, {
    path: "/a/my-caravans",
    component: _e92d5f22,
    name: "account-my-vehicles___es"
  }, {
    path: "/a/my-caravans",
    component: _e92d5f22,
    name: "account-my-vehicles___cs"
  }, {
    path: "/a/nachrichten",
    component: _be2c9210,
    name: "account-messages___de"
  }, {
    path: "/account/email-settings",
    component: _4f498d46,
    name: "account-email-settings___de"
  }, {
    path: "/account/email-settings",
    component: _4f498d46,
    name: "account-email-settings___en"
  }, {
    path: "/account/email-settings",
    component: _4f498d46,
    name: "account-email-settings___nl"
  }, {
    path: "/account/email-settings",
    component: _4f498d46,
    name: "account-email-settings___sv"
  }, {
    path: "/account/email-settings",
    component: _4f498d46,
    name: "account-email-settings___da"
  }, {
    path: "/account/email-settings",
    component: _4f498d46,
    name: "account-email-settings___pl"
  }, {
    path: "/account/email-settings",
    component: _4f498d46,
    name: "account-email-settings___es"
  }, {
    path: "/account/email-settings",
    component: _4f498d46,
    name: "account-email-settings___cs"
  }, {
    path: "/account/messages",
    component: _be2c9210,
    name: "account-messages___da"
  }, {
    path: "/account/my-vehicles",
    component: _e92d5f22,
    name: "account-my-vehicles___da"
  }, {
    path: "/account/settings",
    component: _208a638c,
    name: "account-settings___de"
  }, {
    path: "/account/settings",
    component: _208a638c,
    name: "account-settings___en"
  }, {
    path: "/account/settings",
    component: _208a638c,
    name: "account-settings___nl"
  }, {
    path: "/account/settings",
    component: _208a638c,
    name: "account-settings___sv"
  }, {
    path: "/account/settings",
    component: _208a638c,
    name: "account-settings___da"
  }, {
    path: "/account/settings",
    component: _208a638c,
    name: "account-settings___pl"
  }, {
    path: "/account/settings",
    component: _208a638c,
    name: "account-settings___es"
  }, {
    path: "/account/settings",
    component: _208a638c,
    name: "account-settings___cs"
  }, {
    path: "/ad/new",
    component: _542a85ce,
    name: "sell___en"
  }, {
    path: "/advertentie/nieuw",
    component: _542a85ce,
    name: "sell___nl"
  }, {
    path: "/anuncio/nuevo",
    component: _542a85ce,
    name: "sell___es"
  }, {
    path: "/auth/logged-in",
    component: _27e02530,
    name: "auth-logged-in___de"
  }, {
    path: "/auth/logged-in",
    component: _27e02530,
    name: "auth-logged-in___en"
  }, {
    path: "/auth/logged-in",
    component: _27e02530,
    name: "auth-logged-in___nl"
  }, {
    path: "/auth/logged-in",
    component: _27e02530,
    name: "auth-logged-in___sv"
  }, {
    path: "/auth/logged-in",
    component: _27e02530,
    name: "auth-logged-in___da"
  }, {
    path: "/auth/logged-in",
    component: _27e02530,
    name: "auth-logged-in___pl"
  }, {
    path: "/auth/logged-in",
    component: _27e02530,
    name: "auth-logged-in___es"
  }, {
    path: "/auth/logged-in",
    component: _27e02530,
    name: "auth-logged-in___cs"
  }, {
    path: "/auth/login",
    component: _30ab8ac9,
    name: "auth-login___de"
  }, {
    path: "/auth/login",
    component: _30ab8ac9,
    name: "auth-login___en"
  }, {
    path: "/auth/login",
    component: _30ab8ac9,
    name: "auth-login___nl"
  }, {
    path: "/auth/login",
    component: _30ab8ac9,
    name: "auth-login___sv"
  }, {
    path: "/auth/login",
    component: _30ab8ac9,
    name: "auth-login___da"
  }, {
    path: "/auth/login",
    component: _30ab8ac9,
    name: "auth-login___pl"
  }, {
    path: "/auth/login",
    component: _30ab8ac9,
    name: "auth-login___es"
  }, {
    path: "/auth/login",
    component: _30ab8ac9,
    name: "auth-login___cs"
  }, {
    path: "/auth/redirect-to-authorize",
    component: _ca8fbd70,
    name: "auth-redirect-to-authorize___de"
  }, {
    path: "/auth/redirect-to-authorize",
    component: _ca8fbd70,
    name: "auth-redirect-to-authorize___en"
  }, {
    path: "/auth/redirect-to-authorize",
    component: _ca8fbd70,
    name: "auth-redirect-to-authorize___nl"
  }, {
    path: "/auth/redirect-to-authorize",
    component: _ca8fbd70,
    name: "auth-redirect-to-authorize___sv"
  }, {
    path: "/auth/redirect-to-authorize",
    component: _ca8fbd70,
    name: "auth-redirect-to-authorize___da"
  }, {
    path: "/auth/redirect-to-authorize",
    component: _ca8fbd70,
    name: "auth-redirect-to-authorize___pl"
  }, {
    path: "/auth/redirect-to-authorize",
    component: _ca8fbd70,
    name: "auth-redirect-to-authorize___es"
  }, {
    path: "/auth/redirect-to-authorize",
    component: _ca8fbd70,
    name: "auth-redirect-to-authorize___cs"
  }, {
    path: "/auth/signing-in",
    component: _362112bd,
    name: "auth-signing-in___de"
  }, {
    path: "/auth/signing-in",
    component: _362112bd,
    name: "auth-signing-in___en"
  }, {
    path: "/auth/signing-in",
    component: _362112bd,
    name: "auth-signing-in___nl"
  }, {
    path: "/auth/signing-in",
    component: _362112bd,
    name: "auth-signing-in___sv"
  }, {
    path: "/auth/signing-in",
    component: _362112bd,
    name: "auth-signing-in___da"
  }, {
    path: "/auth/signing-in",
    component: _362112bd,
    name: "auth-signing-in___pl"
  }, {
    path: "/auth/signing-in",
    component: _362112bd,
    name: "auth-signing-in___es"
  }, {
    path: "/auth/signing-in",
    component: _362112bd,
    name: "auth-signing-in___cs"
  }, {
    path: "/auth/verify",
    component: _11fe3a49,
    name: "auth-verify___de"
  }, {
    path: "/auth/verify",
    component: _11fe3a49,
    name: "auth-verify___en"
  }, {
    path: "/auth/verify",
    component: _11fe3a49,
    name: "auth-verify___nl"
  }, {
    path: "/auth/verify",
    component: _11fe3a49,
    name: "auth-verify___sv"
  }, {
    path: "/auth/verify",
    component: _11fe3a49,
    name: "auth-verify___da"
  }, {
    path: "/auth/verify",
    component: _11fe3a49,
    name: "auth-verify___pl"
  }, {
    path: "/auth/verify",
    component: _11fe3a49,
    name: "auth-verify___es"
  }, {
    path: "/auth/verify",
    component: _11fe3a49,
    name: "auth-verify___cs"
  }, {
    path: "/inserat/neu",
    component: _542a85ce,
    name: "sell___de"
  }, {
    path: "/reklama/novy",
    component: _542a85ce,
    name: "sell___cs"
  }, {
    path: "/reklama/nowy",
    component: _542a85ce,
    name: "sell___pl"
  }, {
    path: "/reklame/ny",
    component: _542a85ce,
    name: "sell___da"
  }, {
    path: "/valuate-my-motorhome/success",
    component: _7c2c93da,
    name: "vmm-success___en"
  }, {
    path: "/valuate-my-trailer/success",
    component: _477ee39a,
    name: "vmt-success___en"
  }, {
    path: "/vmm/success",
    component: _7c2c93da,
    name: "vmm-success___nl"
  }, {
    path: "/vmm/success",
    component: _7c2c93da,
    name: "vmm-success___sv"
  }, {
    path: "/vmm/success",
    component: _7c2c93da,
    name: "vmm-success___da"
  }, {
    path: "/vmm/success",
    component: _7c2c93da,
    name: "vmm-success___pl"
  }, {
    path: "/vmm/success",
    component: _7c2c93da,
    name: "vmm-success___es"
  }, {
    path: "/vmm/success",
    component: _7c2c93da,
    name: "vmm-success___cs"
  }, {
    path: "/vmt/success",
    component: _477ee39a,
    name: "vmt-success___nl"
  }, {
    path: "/vmt/success",
    component: _477ee39a,
    name: "vmt-success___sv"
  }, {
    path: "/vmt/success",
    component: _477ee39a,
    name: "vmt-success___da"
  }, {
    path: "/vmt/success",
    component: _477ee39a,
    name: "vmt-success___pl"
  }, {
    path: "/vmt/success",
    component: _477ee39a,
    name: "vmt-success___es"
  }, {
    path: "/vmt/success",
    component: _477ee39a,
    name: "vmt-success___cs"
  }, {
    path: "/wohnmobil-bewerten/uebermittelung-erfolgreich",
    component: _7c2c93da,
    name: "vmm-success___de"
  }, {
    path: "/wohnwagen-bewerten/uebermittelung-erfolgreich",
    component: _477ee39a,
    name: "vmt-success___de"
  }, {
    path: "/a/haendler-bereich/inserate",
    component: _024b3fd2,
    name: "account-merchant-ads___de"
  }, {
    path: "/a/haendler-bereich/integrationen",
    component: _1ab7bfb0,
    name: "account-merchant-integrations___de"
  }, {
    path: "/a/haendler-bereich/kaeufe",
    component: _7767db98,
    name: "account-merchant-purchases___de"
  }, {
    path: "/a/haendler-bereich/neuigkeiten",
    component: _661d7ebe,
    name: "account-merchant-news___de"
  }, {
    path: "/a/haendler-bereich/richtlinien",
    component: _5f388ed1,
    name: "account-merchant-guidelines___de"
  }, {
    path: "/a/haendler-bereich/suchen",
    component: _dcb0ccb8,
    name: "account-merchant-searches___de"
  }, {
    path: "/a/merchant-area/guidelines",
    component: _5f388ed1,
    name: "account-merchant-guidelines___en"
  }, {
    path: "/a/merchant-area/guidelines",
    component: _5f388ed1,
    name: "account-merchant-guidelines___nl"
  }, {
    path: "/a/merchant-area/guidelines",
    component: _5f388ed1,
    name: "account-merchant-guidelines___sv"
  }, {
    path: "/a/merchant-area/guidelines",
    component: _5f388ed1,
    name: "account-merchant-guidelines___pl"
  }, {
    path: "/a/merchant-area/guidelines",
    component: _5f388ed1,
    name: "account-merchant-guidelines___es"
  }, {
    path: "/a/merchant-area/guidelines",
    component: _5f388ed1,
    name: "account-merchant-guidelines___cs"
  }, {
    path: "/a/merchant-area/integrations",
    component: _1ab7bfb0,
    name: "account-merchant-integrations___en"
  }, {
    path: "/a/merchant-area/my-ads",
    component: _024b3fd2,
    name: "account-merchant-ads___en"
  }, {
    path: "/a/merchant-area/my-ads",
    component: _024b3fd2,
    name: "account-merchant-ads___nl"
  }, {
    path: "/a/merchant-area/my-ads",
    component: _024b3fd2,
    name: "account-merchant-ads___sv"
  }, {
    path: "/a/merchant-area/my-ads",
    component: _024b3fd2,
    name: "account-merchant-ads___pl"
  }, {
    path: "/a/merchant-area/my-ads",
    component: _024b3fd2,
    name: "account-merchant-ads___es"
  }, {
    path: "/a/merchant-area/my-ads",
    component: _024b3fd2,
    name: "account-merchant-ads___cs"
  }, {
    path: "/a/merchant-area/news",
    component: _661d7ebe,
    name: "account-merchant-news___en"
  }, {
    path: "/a/merchant-area/news",
    component: _661d7ebe,
    name: "account-merchant-news___nl"
  }, {
    path: "/a/merchant-area/news",
    component: _661d7ebe,
    name: "account-merchant-news___sv"
  }, {
    path: "/a/merchant-area/news",
    component: _661d7ebe,
    name: "account-merchant-news___pl"
  }, {
    path: "/a/merchant-area/news",
    component: _661d7ebe,
    name: "account-merchant-news___es"
  }, {
    path: "/a/merchant-area/news",
    component: _661d7ebe,
    name: "account-merchant-news___cs"
  }, {
    path: "/a/merchant-area/purchases",
    component: _7767db98,
    name: "account-merchant-purchases___en"
  }, {
    path: "/a/merchant-area/purchases",
    component: _7767db98,
    name: "account-merchant-purchases___nl"
  }, {
    path: "/a/merchant-area/purchases",
    component: _7767db98,
    name: "account-merchant-purchases___sv"
  }, {
    path: "/a/merchant-area/purchases",
    component: _7767db98,
    name: "account-merchant-purchases___pl"
  }, {
    path: "/a/merchant-area/purchases",
    component: _7767db98,
    name: "account-merchant-purchases___es"
  }, {
    path: "/a/merchant-area/purchases",
    component: _7767db98,
    name: "account-merchant-purchases___cs"
  }, {
    path: "/a/merchant-area/searches",
    component: _dcb0ccb8,
    name: "account-merchant-searches___en"
  }, {
    path: "/a/merchant-area/searches",
    component: _dcb0ccb8,
    name: "account-merchant-searches___nl"
  }, {
    path: "/a/merchant-area/searches",
    component: _dcb0ccb8,
    name: "account-merchant-searches___sv"
  }, {
    path: "/a/merchant-area/searches",
    component: _dcb0ccb8,
    name: "account-merchant-searches___pl"
  }, {
    path: "/a/merchant-area/searches",
    component: _dcb0ccb8,
    name: "account-merchant-searches___es"
  }, {
    path: "/a/merchant-area/searches",
    component: _dcb0ccb8,
    name: "account-merchant-searches___cs"
  }, {
    path: "/account/merchant/ads",
    component: _024b3fd2,
    name: "account-merchant-ads___da"
  }, {
    path: "/account/merchant/guidelines",
    component: _5f388ed1,
    name: "account-merchant-guidelines___da"
  }, {
    path: "/account/merchant/integrations",
    component: _1ab7bfb0,
    name: "account-merchant-integrations___nl"
  }, {
    path: "/account/merchant/integrations",
    component: _1ab7bfb0,
    name: "account-merchant-integrations___sv"
  }, {
    path: "/account/merchant/integrations",
    component: _1ab7bfb0,
    name: "account-merchant-integrations___da"
  }, {
    path: "/account/merchant/integrations",
    component: _1ab7bfb0,
    name: "account-merchant-integrations___pl"
  }, {
    path: "/account/merchant/integrations",
    component: _1ab7bfb0,
    name: "account-merchant-integrations___es"
  }, {
    path: "/account/merchant/integrations",
    component: _1ab7bfb0,
    name: "account-merchant-integrations___cs"
  }, {
    path: "/account/merchant/news",
    component: _661d7ebe,
    name: "account-merchant-news___da"
  }, {
    path: "/account/merchant/purchases",
    component: _7767db98,
    name: "account-merchant-purchases___da"
  }, {
    path: "/account/merchant/searches",
    component: _dcb0ccb8,
    name: "account-merchant-searches___da"
  }, {
    path: "/account/merchant/watchlist",
    component: _576a470f,
    name: "account-merchant-watchlist___de"
  }, {
    path: "/account/merchant/watchlist",
    component: _576a470f,
    name: "account-merchant-watchlist___en"
  }, {
    path: "/account/merchant/watchlist",
    component: _576a470f,
    name: "account-merchant-watchlist___nl"
  }, {
    path: "/account/merchant/watchlist",
    component: _576a470f,
    name: "account-merchant-watchlist___sv"
  }, {
    path: "/account/merchant/watchlist",
    component: _576a470f,
    name: "account-merchant-watchlist___da"
  }, {
    path: "/account/merchant/watchlist",
    component: _576a470f,
    name: "account-merchant-watchlist___pl"
  }, {
    path: "/account/merchant/watchlist",
    component: _576a470f,
    name: "account-merchant-watchlist___es"
  }, {
    path: "/account/merchant/watchlist",
    component: _576a470f,
    name: "account-merchant-watchlist___cs"
  }, {
    path: "/a/haendler-bereich/integrationen/syscara",
    component: _2e2fe4b8,
    name: "account-merchant-integrations-syscara___de"
  }, {
    path: "/a/merchant-area/integrations/syscara",
    component: _2e2fe4b8,
    name: "account-merchant-integrations-syscara___en"
  }, {
    path: "/account/merchant/integrations/syscara",
    component: _2e2fe4b8,
    name: "account-merchant-integrations-syscara___nl"
  }, {
    path: "/account/merchant/integrations/syscara",
    component: _2e2fe4b8,
    name: "account-merchant-integrations-syscara___sv"
  }, {
    path: "/account/merchant/integrations/syscara",
    component: _2e2fe4b8,
    name: "account-merchant-integrations-syscara___da"
  }, {
    path: "/account/merchant/integrations/syscara",
    component: _2e2fe4b8,
    name: "account-merchant-integrations-syscara___pl"
  }, {
    path: "/account/merchant/integrations/syscara",
    component: _2e2fe4b8,
    name: "account-merchant-integrations-syscara___es"
  }, {
    path: "/account/merchant/integrations/syscara",
    component: _2e2fe4b8,
    name: "account-merchant-integrations-syscara___cs"
  }, {
    path: "/",
    component: _1479741b,
    name: "index___de"
  }, {
    path: "/",
    component: _1479741b,
    name: "index___en"
  }, {
    path: "/",
    component: _1479741b,
    name: "index___nl"
  }, {
    path: "/",
    component: _1479741b,
    name: "index___sv"
  }, {
    path: "/",
    component: _1479741b,
    name: "index___da"
  }, {
    path: "/",
    component: _1479741b,
    name: "index___pl"
  }, {
    path: "/",
    component: _1479741b,
    name: "index___es"
  }, {
    path: "/",
    component: _1479741b,
    name: "index___cs"
  }, {
    path: "/account/messages/thread/:slug?",
    component: _35b6c1e2,
    name: "account-messages-thread-slug___da"
  }, {
    path: "/a/messages/:slug",
    component: _35b6c1e2,
    name: "account-messages-thread-slug___en"
  }, {
    path: "/a/messages/:slug",
    component: _35b6c1e2,
    name: "account-messages-thread-slug___nl"
  }, {
    path: "/a/messages/:slug",
    component: _35b6c1e2,
    name: "account-messages-thread-slug___sv"
  }, {
    path: "/a/messages/:slug",
    component: _35b6c1e2,
    name: "account-messages-thread-slug___pl"
  }, {
    path: "/a/messages/:slug",
    component: _35b6c1e2,
    name: "account-messages-thread-slug___es"
  }, {
    path: "/a/messages/:slug",
    component: _35b6c1e2,
    name: "account-messages-thread-slug___cs"
  }, {
    path: "/a/nachrichten/:slug",
    component: _35b6c1e2,
    name: "account-messages-thread-slug___de"
  }, {
    path: "/ad/continue/:id",
    component: _db0bd7e6,
    name: "vstepper-id___en"
  }, {
    path: "/advertentie/doorgaan/:id",
    component: _db0bd7e6,
    name: "vstepper-id___nl"
  }, {
    path: "/anuncio/continuar/:id",
    component: _db0bd7e6,
    name: "vstepper-id___es"
  }, {
    path: "/blog/author/:slug",
    component: _9ebfdec8,
    name: "blog-author-slug___de"
  }, {
    path: "/blog/author/:slug?",
    component: _9ebfdec8,
    name: "blog-author-slug___en"
  }, {
    path: "/blog/author/:slug?",
    component: _9ebfdec8,
    name: "blog-author-slug___nl"
  }, {
    path: "/blog/author/:slug?",
    component: _9ebfdec8,
    name: "blog-author-slug___sv"
  }, {
    path: "/blog/author/:slug?",
    component: _9ebfdec8,
    name: "blog-author-slug___da"
  }, {
    path: "/blog/author/:slug?",
    component: _9ebfdec8,
    name: "blog-author-slug___pl"
  }, {
    path: "/blog/author/:slug?",
    component: _9ebfdec8,
    name: "blog-author-slug___es"
  }, {
    path: "/blog/author/:slug?",
    component: _9ebfdec8,
    name: "blog-author-slug___cs"
  }, {
    path: "/catalog/product/:id?",
    component: _b1a397a6,
    name: "catalog-product-id___nl"
  }, {
    path: "/catalog/product/:id?",
    component: _b1a397a6,
    name: "catalog-product-id___sv"
  }, {
    path: "/catalog/product/:id?",
    component: _b1a397a6,
    name: "catalog-product-id___da"
  }, {
    path: "/catalog/product/:id?",
    component: _b1a397a6,
    name: "catalog-product-id___pl"
  }, {
    path: "/catalog/product/:id?",
    component: _b1a397a6,
    name: "catalog-product-id___es"
  }, {
    path: "/catalog/product/:id?",
    component: _b1a397a6,
    name: "catalog-product-id___cs"
  }, {
    path: "/inserat/fortsetzen/:id",
    component: _db0bd7e6,
    name: "vstepper-id___de"
  }, {
    path: "/ohodnotit-muj-motorhome/your-valuation/:all(.*)*",
    component: _ebc41e38,
    name: "vmm-report-all___cs"
  }, {
    path: "/valora-mi-autocaravana/your-valuation/:all(.*)*",
    component: _ebc41e38,
    name: "vmm-report-all___es"
  }, {
    path: "/ocen-moj-kamper/your-valuation/:all(.*)*",
    component: _ebc41e38,
    name: "vmm-report-all___pl"
  }, {
    path: "/reklama/koniec/:id",
    component: _db0bd7e6,
    name: "vstepper-id___pl"
  }, {
    path: "/reklama/pokracovat/:id",
    component: _db0bd7e6,
    name: "vstepper-id___cs"
  }, {
    path: "/reklame/fortsaet/:id",
    component: _db0bd7e6,
    name: "vstepper-id___da"
  }, {
    path: "/vurder-min-autocamper/your-valuation/:all(.*)*",
    component: _ebc41e38,
    name: "vmm-report-all___da"
  }, {
    path: "/vaerdera-min-husbil/your-valuation/:all(.*)*",
    component: _ebc41e38,
    name: "vmm-report-all___sv"
  }, {
    path: "/waardeer-mijn-camper/your-valuation/:all(.*)*",
    component: _ebc41e38,
    name: "vmm-report-all___nl"
  }, {
    path: "/valuate-my-motorhome/your-valuation/:all(.*)*",
    component: _ebc41e38,
    name: "vmm-report-all___en"
  }, {
    path: "/wohnmobil-bewerten/ihre-bewertung/:all(.*)*",
    component: _ebc41e38,
    name: "vmm-report-all___de"
  }, {
    path: "/valuate-my-trailer/your-valuation/:slug",
    component: _75d49230,
    name: "vmt-report-slug___en"
  }, {
    path: "/vmt/report/:slug?",
    component: _75d49230,
    name: "vmt-report-slug___nl"
  }, {
    path: "/vmt/report/:slug?",
    component: _75d49230,
    name: "vmt-report-slug___sv"
  }, {
    path: "/vmt/report/:slug?",
    component: _75d49230,
    name: "vmt-report-slug___da"
  }, {
    path: "/vmt/report/:slug?",
    component: _75d49230,
    name: "vmt-report-slug___pl"
  }, {
    path: "/vmt/report/:slug?",
    component: _75d49230,
    name: "vmt-report-slug___es"
  }, {
    path: "/vmt/report/:slug?",
    component: _75d49230,
    name: "vmt-report-slug___cs"
  }, {
    path: "/wohnwagen-bewerten/ihre-bewertung/:slug",
    component: _75d49230,
    name: "vmt-report-slug___de"
  }, {
    path: "/caravan/:id",
    component: _b1a397a6,
    name: "catalog-product-id___de"
  }, {
    path: "/caravan/:id",
    component: _b1a397a6,
    name: "catalog-product-id___en"
  }, {
    path: "/ocen-moj-kamper/step-:step-of-2",
    component: _5e37ffbb,
    name: "vmm-step___pl"
  }, {
    path: "/ohodnotit-muj-motorhome/step-:step-of-2",
    component: _5e37ffbb,
    name: "vmm-step___cs"
  }, {
    path: "/valora-mi-autocaravana/step-:step-of-2",
    component: _5e37ffbb,
    name: "vmm-step___es"
  }, {
    path: "/valuate-my-motorhome/step-:step-of-2",
    component: _5e37ffbb,
    name: "vmm-step___en"
  }, {
    path: "/vmm/:step",
    component: _5e37ffbb,
    name: "vmm-step___sv"
  }, {
    path: "/vstepper/:id?",
    component: _db0bd7e6,
    name: "vstepper-id___sv"
  }, {
    path: "/vurder-min-autocamper/step-:step-of-2",
    component: _5e37ffbb,
    name: "vmm-step___da"
  }, {
    path: "/waardeer-mijn-camper/step-:step-of-2",
    component: _5e37ffbb,
    name: "vmm-step___nl"
  }, {
    path: "/wohnmobil-bewerten/schritt-:step-von-2",
    component: _5e37ffbb,
    name: "vmm-step___de"
  }, {
    path: "/av/:auctionId/:uuid",
    component: _5c9b6447,
    name: "availability-auctionId-uuid___de"
  }, {
    path: "/av/:auctionId/:uuid",
    component: _5c9b6447,
    name: "availability-auctionId-uuid___en"
  }, {
    path: "/av/:auctionId/:uuid",
    component: _5c9b6447,
    name: "availability-auctionId-uuid___nl"
  }, {
    path: "/av/:auctionId/:uuid",
    component: _5c9b6447,
    name: "availability-auctionId-uuid___sv"
  }, {
    path: "/av/:auctionId/:uuid",
    component: _5c9b6447,
    name: "availability-auctionId-uuid___pl"
  }, {
    path: "/av/:auctionId/:uuid",
    component: _5c9b6447,
    name: "availability-auctionId-uuid___es"
  }, {
    path: "/av/:auctionId/:uuid",
    component: _5c9b6447,
    name: "availability-auctionId-uuid___cs"
  }, {
    path: "/availability/:auctionId?/:uuid?",
    component: _5c9b6447,
    name: "availability-auctionId-uuid___da"
  }, {
    path: "/*",
    component: _3df784b0,
    name: "all___cs"
  }, {
    path: "/*",
    component: _3df784b0,
    name: "all___es"
  }, {
    path: "/*",
    component: _3df784b0,
    name: "all___pl"
  }, {
    path: "/*",
    component: _3df784b0,
    name: "all___da"
  }, {
    path: "/*",
    component: _3df784b0,
    name: "all___sv"
  }, {
    path: "/*",
    component: _3df784b0,
    name: "all___nl"
  }, {
    path: "/*",
    component: _3df784b0,
    name: "all___en"
  }, {
    path: "/*",
    component: _3df784b0,
    name: "all___de"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
